import { ref } from "vue";
import { useNuxtApp } from "#imports";
export function useModelAuthPermissions() {
  const { $apiFetch } = useNuxtApp();
  const authPermissions = ref({});
  const refreshAuthPermissions = async (modelType, modelId) => {
    authPermissions.value = await loadPermissions(modelType, modelId);
  };
  const loadPermissions = (modelType, modelId) => {
    return new Promise((resolve, reject) => {
      $apiFetch("/v1/auth/permissions", {
        params: {
          model_type: modelType,
          model_id: modelId
        }
      }).then((data) => {
        resolve(data.data);
      }).catch((e) => {
        reject(e);
      });
    });
  };
  return {
    authPermissions,
    refreshAuthPermissions
  };
}
